import { useState } from "react";
import { ClickAwayListener } from "@mui/base";
import { IconButton, Tooltip } from "@mui/material";

const EventPopular = ({ event }) => {
    const [open, setOpen] = useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        open ? setOpen(false) : setOpen(true);
    };

    return (
        <>
            {event.popular && (
                <ClickAwayListener onClickAway={handleTooltipClose}>
                    <Tooltip 
                        title="Popular"
                        placement="top"
                        onClose={handleTooltipClose}
                        open={open}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                    >
                        <IconButton 
                            onClick={handleTooltipOpen}
                            size={"small"}
                            sx={{ backgroundColor: "#000000", border:"1px solid #535353", paddingTop: 0, marginTop: "0px", marginLeft: "8px" }}
                            variant={"contained"}
                        >
                            <span role="img" aria-label="popular">🔥</span>
                        </IconButton>
                    </Tooltip>
                </ClickAwayListener>
            )}
        </>
    );
};

export default EventPopular;